// src/app/features/user/user.component.ts
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user.type';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { selectUser } from 'app/_store/userStore/user.selectors';
import { loadUser } from 'app/_store/userStore/user.actions';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html'
})
export class UserComponent implements OnInit {
  user$: Observable<User | null>; // Observable for user data
  users$ = this.store.select(selectUser);

  constructor(
    private userService: UserService,
    private store: Store,
    private router: Router
  ) {
    // Initialize the user$ observable
    this.user$ = this.userService.getUser(); // Fetch user data
  }

  ngOnInit() {
    this.store.dispatch(loadUser());
  }

  update(user: User): void {
    // Implement the logic to update the user's profile
    this.userService.updateUser(user).subscribe(() => {
      // Handle post-update actions, like showing a message or re-fetching user data
    });
  }

  goToProducts() {
    this.router.navigate(['/testProduct']);
  }
}
